import { useEffect, useState } from 'react';

/** Board 1.1: one beat every 2.6 s, the heart held at 1.16 for 300 ms. */
export const HEART_BEAT_INTERVAL_MS = 2600;
export const HEART_BEAT_HOLD_MS = 300;

/**
 * The idle heart's beat: true for a moment every 2.6 s while `isActive` and
 * the page is visible.
 */
export const useHeartBeat = (isActive: boolean) => {
  const [isBeating, setIsBeating] = useState(false);

  useEffect(() => {
    if (!isActive) {
      setIsBeating(false);

      return;
    }

    let holdTimer: ReturnType<typeof setTimeout> | undefined;
    const interval = setInterval(() => {
      if (document.visibilityState !== 'visible') return;

      setIsBeating(true);
      clearTimeout(holdTimer);
      holdTimer = setTimeout(() => setIsBeating(false), HEART_BEAT_HOLD_MS);
    }, HEART_BEAT_INTERVAL_MS);

    return () => {
      clearInterval(interval);
      clearTimeout(holdTimer);
    };
  }, [isActive]);

  return isBeating;
};
